export default {"src":"/_next/static/media/coco_pointing.c19158a5.svg","height":320,"width":357,"blurWidth":0,"blurHeight":0};